export default "/images/blog.png?11f1be6a85b8f1d756278020c7a37b3b";